import { FiClock, FiInfo, FiSlash } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import type { WrappedStatus } from "../types";

interface WrappedEmptyStateProps {
  status?: WrappedStatus;
  reason?: string | null;
  isNotFound?: boolean;
  isError?: boolean;
}

export const WrappedEmptyState = ({ status, reason, isNotFound = false, isError = false }: WrappedEmptyStateProps) => {
  const { t } = useTranslation("wrapped");

  const state = isError
    ? { icon: FiInfo, message: t("wrapped.loadError") }
    : isNotFound
      ? { icon: FiSlash, message: t("wrapped.noReport") }
      : status === "INELIGIBLE" && reason === "NOT_ENOUGH_TRANSACTIONS"
        ? { icon: FiInfo, message: t("wrapped.noTransactions") }
        : status === "INELIGIBLE" && reason === "NOT_ENOUGH_ACTIVE_DAYS"
          ? { icon: FiInfo, message: t("wrapped.noActiveDays") }
          : { icon: FiClock, message: t("wrapped.pending") };
  const Icon = state.icon;

  return (
    <section
      className="app-panel-raised flex min-h-64 flex-col items-center justify-center p-6 text-center sm:p-10"
      role={isError ? "alert" : "status"}
      aria-live={isError ? "assertive" : "polite"}
    >
      <span className="flex h-12 w-12 items-center justify-center rounded-[var(--ds-radius-md)] bg-[var(--app-primary-soft)] text-[var(--app-primary)]" aria-hidden="true">
        <Icon size={22} />
      </span>
      <p className="mt-5 max-w-md text-base font-semibold leading-7 text-[var(--app-text)]">{state.message}</p>
    </section>
  );
};
